"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Chip_1 = __importStar(require("@atg/icf-react-components/components/Chip"));
var Flex_1 = __importDefault(require("@atg/icf-react-components/components/Flex"));
var Link_1 = __importDefault(require("@atg/icf-react-components/components/Link"));
var Scroller_1 = __importDefault(require("@atg/icf-react-components/components/Scroller"));
var SvgIcon_1 = __importDefault(require("@atg/icf-react-components/components/SvgIcon"));
var Categories_1 = require("icf-search-client-shared/lib/constants/Categories");
var XmentService_1 = require("icf-search-client-shared/lib/services/XmentService");
var react_1 = __importStar(require("react"));
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var HiddenText_1 = require("./HiddenText");
var MOBILE_CATEGORIES = ["mobile", "mobileguy", "tsmobile"];
var GENDER_CATEGORY_NAME = {
    "f,ff,mf,tm2f,g": "livesex",
    "m,mm,tf2m,g": "guycams",
    "tm2f,tf2m,shm": "transcams",
};
var decideSelectedCategoryFromUrl = function (pathname) {
    var pathSegments = pathname.split("/").filter(Boolean);
    var lastUrlSegment = pathSegments[pathSegments.length - 1];
    var secondToLastUrlSegment = pathSegments[pathSegments.length - 2];
    var thirdToLastUrlSegment = pathSegments[pathSegments.length - 3];
    if (!pathSegments.length) {
        return;
    }
    // e.g. https://streamate.com/browse/livesex/bigtits/page/2
    if (secondToLastUrlSegment === "page") {
        return thirdToLastUrlSegment;
    }
    // e.g. https://streamate.com/browse/livesex/bigtits/2
    if (!isNaN(Number(lastUrlSegment))) {
        return secondToLastUrlSegment;
    }
    // e.g. https://streamate.com/browse/livesex/bigtits/
    return lastUrlSegment;
};
var sortAlphabetically = function (_a, _b) {
    var categoryADisplayName = _a.displayName;
    var categoryBDisplayName = _b.displayName;
    return categoryADisplayName.localeCompare(categoryBDisplayName);
};
var SearchResultsCategoryScroller = function (_a) {
    var categoryGroups = _a.categoryGroups, genderFilter = _a.genderFilter, showSearchIcon = _a.showSearchIcon, openMobileFilterModal = _a.openMobileFilterModal, isUserAuthenticated = _a.isUserAuthenticated;
    var _b = __read((0, Ioc_1.useContexts)(Contexts_1.IXmentServiceContext), 1), xmentService = _b[0];
    var _c = __read((0, react_1.useState)([]), 2), categoriesToShow = _c[0], setCategoriesToShow = _c[1];
    var _d = __read((0, react_1.useState)(""), 2), selectedCategory = _d[0], setSelectedCategory = _d[1];
    var _e = __read((0, Ioc_1.useContexts)(Contexts_1.ILinkComponentContext, Contexts_1.IThemeContext, Contexts_1.IRouterContext, Contexts_1.ITranslationServiceContext, Contexts_1.IUserContext), 5), Link = _e[0], theme = _e[1], router = _e[2], translate = _e[3].translate, user = _e[4];
    var isMobileXmentEnabled = xmentService === null || xmentService === void 0 ? void 0 : xmentService.isXmentVariationOn(XmentService_1.SEARCH_MOBILE_CATEGORY);
    var showFilterIcon = isUserAuthenticated &&
        (categoryGroups.length === 1 || (xmentService && xmentService.getXmentVariation(XmentService_1.FILTER_LOCATION_MOBILE) === "B"));
    (0, react_1.useEffect)(function () {
        var genderCategoryName = GENDER_CATEGORY_NAME[(genderFilter === null || genderFilter === void 0 ? void 0 : genderFilter.value) || ""];
        var categoriesForGender = categoryGroups.find(function (categoryGroup) {
            // this is for edge case, because on trans only whitelabels like tsmate.com, category group is "specialtycams" instead of "transcams"
            // @ts-ignore
            if ((genderFilter === null || genderFilter === void 0 ? void 0 : genderFilter.value) === "tm2f,tf2m,shm" && categoryGroup.name === "specialtycams") {
                genderCategoryName = "transcams";
                return true;
            }
            return categoryGroup.name === genderCategoryName;
        });
        if (!genderCategoryName || !categoriesForGender) {
            return;
        }
        var sortedCategoriesForGender = categoriesForGender.categories
            .filter(function (category) { return !!category.liveCount; })
            .filter(function (category) { return !MOBILE_CATEGORIES.includes(category.name) || isMobileXmentEnabled; })
            .reduce(function (accumulatedCategories, currentCategory) {
            var displayName = Categories_1.CATEGORIES_TO_DISPLAY[genderCategoryName][currentCategory.name];
            if (!currentCategory.liveCount || !displayName) {
                return accumulatedCategories;
            }
            var updatedCategory = __assign(__assign({}, currentCategory), { displayName: translate("categories.".concat(displayName)) });
            accumulatedCategories.push(updatedCategory);
            return accumulatedCategories;
        }, [])
            .sort(sortAlphabetically);
        setCategoriesToShow(sortedCategoriesForGender);
    }, [genderFilter, categoryGroups, selectedCategory, translate]);
    (0, react_1.useEffect)(function () {
        var _a;
        var category = decideSelectedCategoryFromUrl(router.location.pathname) || ((_a = categoriesToShow[0]) === null || _a === void 0 ? void 0 : _a.name);
        setSelectedCategory(category);
    }, [categoriesToShow, router.location.pathname]);
    var getSkeletonLength = function (textLength) {
        var length = Math.min(15, textLength !== null && textLength !== void 0 ? textLength : 0);
        var normalizedLength = Math.max(4, length);
        return "".concat(normalizedLength * 0.8, "rem");
    };
    var renderCategoryChips = function (categories) {
        var _a;
        if (categories === void 0) { categories = []; }
        var isTextBlurEnabled = (_a = user === null || user === void 0 ? void 0 : user.ageVerificationRules) === null || _a === void 0 ? void 0 : _a.isTextBlurEnabled;
        return categories.map(function (_a) {
            var url = _a.url, name = _a.name, displayName = _a.displayName;
            return (react_1.default.createElement(Link, { key: displayName, to: url, style: { whiteSpace: "nowrap" } },
                react_1.default.createElement(Chip_1.default, { value: name }, isTextBlurEnabled ? (react_1.default.createElement(HiddenText_1.HiddenText, { text: displayName, width: getSkeletonLength(displayName === null || displayName === void 0 ? void 0 : displayName.length) })) : (displayName))));
        });
    };
    // Scroll the category bar so that the active chip is visible
    var scrollContainer = document.querySelector("[class*='Scroller-bar-']");
    var activeCategoryChip = scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.querySelector("input[type='radio']:checked");
    if (scrollContainer && activeCategoryChip && activeCategoryChip.parentElement) {
        var elementLeft = activeCategoryChip.parentElement.offsetLeft;
        var elementRight = elementLeft + activeCategoryChip.parentElement.offsetWidth;
        var scrollLeft = scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.scrollLeft;
        var containerWidth = scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.clientWidth;
        if (elementLeft < scrollLeft || elementRight > scrollLeft + containerWidth) {
            scrollContainer.scrollTo({
                // eslint-disable-next-line @atg/css-rtl-support
                left: elementLeft - 20,
            });
        }
    }
    return (react_1.default.createElement(Flex_1.default, { width: "100%", overflowX: "hidden", background: "pageBackground", padding: 0, direction: "row", gap: 8 },
        react_1.default.createElement(Scroller_1.default, { "data-ta-locator": "CategoryScroller", style: __assign({ paddingBlock: theme.spacing.base, minHeight: "48px" }, (showSearchIcon && { maxWidth: "calc(100% + 40px)" })), shadowColor: "pageBackground", width: "100%" },
            react_1.default.createElement(Chip_1.ChipGroup, { name: "radio-controlled", selected: selectedCategory, marginLeft: theme.spacing.base, marginRight: theme.spacing.base }, renderCategoryChips(categoriesToShow))),
        showFilterIcon && (react_1.default.createElement(Flex_1.default, { borderWidth: "0 0 0 1", borderColor: "baseContrast015", padding: "0 8" },
            react_1.default.createElement(Chip_1.default, { size: "medium", checked: false, value: "" },
                react_1.default.createElement(Link_1.default, { onClick: openMobileFilterModal },
                    react_1.default.createElement(SvgIcon_1.default, { name: "filter", fill: "baseContrast100", size: "medium" })))))));
};
exports.default = SearchResultsCategoryScroller;
//# sourceMappingURL=SearchResultsCategoryScroller.js.map